// @ts-nocheck
import React from "react";
import PropTypes from "prop-types";

export const SecondaryBtn = ({
  text,
  loading,
  submit = null,
  className = "",
  disabled,
  style = {},
  dataTestId = "",
}) => {
  return (
    <button
      type="button"
      className={`btn btn-secondary ${className}`}
      onClick={submit}
      disabled={disabled}
      style={style}
      data-testid={dataTestId}
    >
      {!loading ? (
        text
      ) : (
        <div className="circular-progress-submit">
          <svg viewBox="22 22 44 44">
            <circle cx="44" cy="44" r="20.2" fill="none" stroke="#222222" strokeWidth="3.6" />
          </svg>
        </div>
      )}
    </button>
  );
};

SecondaryBtn.propTypes = {
  loading: PropTypes.bool,
  text: PropTypes.string,
  submit: PropTypes.func,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  style: PropTypes.object,
  dataTestId: PropTypes.string,
};
